import { default as MissionProgressBar } from "components/navigation/mission/ProgressBar";
import { useMissionExecution } from "providers/navigation/MissionExecutionProvider";
import MissionOverrideButtons from "./MissionOverrideButtons";

const TERMINAL_MISSION_STATUSES = new Set([
    "idle",
    "completed",
    "failed",
    "cancelled",
    "canceled",
    "succeeded",
]);

const MissionControls = () => {
    const { isExecuting, currentMissionId, executorState } = useMissionExecution();
    const normalizedExecutorStatus = String(executorState?.status || "").trim().toLowerCase();
    const normalizedExecutorMissionId = String(executorState?.mission_id || "").trim();
    const isExecutorMissionActive =
        Boolean(normalizedExecutorMissionId) && !TERMINAL_MISSION_STATUSES.has(normalizedExecutorStatus);
    const normalizedRunningMissionId = String(currentMissionId || "").trim();
    const activeMissionId =
        (isExecutorMissionActive && normalizedExecutorMissionId) ||
        (isExecuting && normalizedRunningMissionId) ||
        null;

    return (
        <div className="relative isolate inline-flex shrink-0 gap-x-4 rounded-r10 p-2">
            {activeMissionId && (
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-0 -z-10 rounded-r10 bg-primary/20 motion-safe:animate-breathe"
                />
            )}
            <MissionOverrideButtons />
            <MissionProgressBar />
        </div>
    );
};

export default MissionControls;
